export default __webpack_public_path__ + "static/media/header-back.d383c3fe.jpg";